import {mapState} from "vuex";

export default {
  name: 'PermissionsMixin',

  data() {
    return {
      authUser: JSON.parse(window.localStorage.getItem('auth_ehealth')),
    };
  },

  computed: {
    ...mapState({
      permissions: state => state.app.permissions,
      company: state => state.account.authUser.company,
      companyPermissions: state => state.account.authUser.company.permissions,
      ePrescriptionServiceEnabled: state => state.account.authUser?.user?.professional_parapharmacy_prescription_service,
    }),
    electronicPrescriptionAvailable() {
      if (this.company?.id) {
        return (
          (this.permissions.haveElectronicPrescription && this.companyPermissions?.haveElectronicPrescription && this.ePrescriptionServiceEnabled)
        );
      }

      return (
        (this.permissions.haveElectronicPrescription && this.ePrescriptionServiceEnabled)
      );
    },
    pdfPrescriptionAvailable() {
      return this.permissions.settingsBook && this.permissions.prescriptions && this.companyPermissions?.settingsBook && this.companyPermissions?.prescriptions;
    },

    canEmit() {
      return this.electronicPrescriptionAvailable || this.pdfPrescriptionAvailable;
    }
  },
};
